<div class=" wizard labwiz form_wizard overflow-hidden  margin-row ">
  <div class="back_button_div m-2">
      <button class='mat-stroked-button pl-0' (click)="gotoBackPage()"><img src="assets/images/left.png"
          class='table_head_back'> Back </button>
    </div>
  <mat-tab-group>
    <mat-tab label="Notifications">
      <div class="col-12 ">
        <div class="gridCtrls">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="my-1  mr-1">

            </div>

          </div>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="my-1  mr-1">
              <span (click)="deleteNotif('notifications' , 'selection')"><img src="assets/images/delete.svg"></span>
            </div>
            <div class="my-1  mr-1">
              <button mat-stroked-button (click)='updateReadStats("read" , "notifications")'
                [disabled]="selection.selected.length == 0">Mark as read</button>
            </div>
            <div class="my-1  mr-1">
              <button mat-stroked-button (click)='updateReadStats("unread" , "notifications")'
                [disabled]="selection.selected.length == 0">Mark as unread</button>
            </div>
            <div class="my-1  mr-1">
              <span (click)=getNotis()><img src="assets/images/reset.svg"></span>
            </div>


          </div>
        </div>
        <mat-card class="p-0 overflow-hidden iop">
          <div class="mat-elevation-z8 checkBoxlign">
            <div class="table-responsive striped users_mod">
              <table class="col-12" mat-table matSort [dataSource]="notifications">
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="checkbox_width text-center">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row" class="checkbox_width text-center">
                    <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="row.checkbox = $event.checked;$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Date">
                  <th mat-header-cell *matHeaderCellDef> Date </th>
                  <td mat-cell *matCellDef="let element"> {{element.created | date : 'MMM dd, yyyy, hh:mm a'}} </td>
                </ng-container>
                <ng-container matColumnDef="Subject">
                  <th class="date_width" mat-header-cell *matHeaderCellDef>Subject</th>
                  <td mat-cell *matCellDef="let element; let i = index"
                    (click)='getNotifDetails(element,i,"NonDelpage")' [ngClass]='{"unread" : element["has_been_seen"] === "N"}'> {{element.subject}} </td>
                </ng-container>
                <ng-container matColumnDef="Actions">
                  <th class="date_width" mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <div class="action_array">
                      <button mat-button class="read" (click)='$event.stopPropagation();singleRead(element ,"unread")'
                        *ngIf='element["has_been_seen"] === "Y"'>

                      </button>
                      <button mat-button class="unread" *ngIf='element["has_been_seen"] !== "Y"'
                        (click)='$event.stopPropagation();singleRead(element ,"read")'>

                      </button>
                      <button mat-button class="unflaged" *ngIf='element["is_flagged"] === "N"'
                        (click)='$event.stopPropagation();changeFlagstats("Y" , element)'>

                      </button>
                      <button mat-button class="flagged" *ngIf='element["is_flagged"] === "Y"'
                        (click)='$event.stopPropagation();changeFlagstats("N" , element)'>

                      </button>
                    </div>


                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="notifColoumns;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: notifColoumns;"
                  [ngClass]='{"unread" : row["has_been_seen"] === "N"}'></tr>
              </table>
            </div>
          </div>
          <div class="col-12" *ngIf="notifications.length > 0">
            <mat-paginator [pageSizeOptions]="NonDelpage.pageSizeOptions" [length]="NonDelpage.limit"
              [pageSize]="NonDelpage.pageSize" (page)="PageChange($event,'NonDelpage')" [pageIndex]="NonDelpage.index"
              showFirstLastButtons></mat-paginator>
          </div>
          <div class="col-12 text-center p-2" *ngIf="notifications.length == 0">
            No Notifications Found
          </div>
        </mat-card>
      </div>

    </mat-tab>
    <mat-tab label="Unread Notifications">
      <div class="col-12 ">
        <div class="gridCtrls">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="my-1  mr-1">

            </div>

          </div>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="my-1  mr-1">
              <span (click)="deleteNotif('unReadnotifs' ,'Unreadselection' )"><img
                  src="assets/images/delete.svg"></span>
            </div>
            <!-- <div class="my-1  mr-1">
            <button mat-stroked-button (click)='updateReadStats("read")'  [disabled]="selection.selected.length == 0">Mark as read</button>
        </div> -->
            <div class="my-1  mr-1">
              <button mat-stroked-button (click)='updateReadStats("read" , "unReadnotifs")'
                [disabled]="Unreadselection.selected.length == 0">Mark as read</button>
            </div>
            <!-- <div class="my-1  mr-1">
            <span (click)=initNOtif()><img src="assets/images/reset.svg"></span>
          </div>
       -->

          </div>
        </div>
        <mat-card class="p-0 overflow-hidden iop">
          <div class="mat-elevation-z8 checkBoxlign">
            <div class="table-responsive striped users_mod">
              <table class="col-12" mat-table matSort [dataSource]="unReadnotifs">
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="checkbox_width text-center">
                    <mat-checkbox (change)="$event ? masterUnreadToggle() : null"
                      [checked]="Unreadselection.hasValue() && isAllUnreadlSelected()"
                      [indeterminate]="Unreadselection.hasValue() && !isAllUnreadlSelected()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row" class="checkbox_width text-center">
                    <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="row.checkbox = $event.checked;$event ? Unreadselection.toggle(row) : null"
                      [checked]="Unreadselection.isSelected(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Date">
                  <th mat-header-cell *matHeaderCellDef> Date </th>
                  <td mat-cell *matCellDef="let element"> {{element.created |  date : 'MMM dd, yyyy, hh:mm a'}} </td>
                </ng-container>
                <ng-container matColumnDef="Subject">
                  <th class="date_width" mat-header-cell *matHeaderCellDef>Subject</th>
                  <td mat-cell *matCellDef="let element ;let i = index" (click)='getNotifDetails(element,i,"unread")'>
                    {{element.subject}} </td>
                </ng-container>
                <ng-container matColumnDef="Actions">
                  <th class="date_width" mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <div class="action_array">
                      <button mat-button class="read" (click)='$event.stopPropagation();singleRead(element ,"unread")'
                        *ngIf='element["has_been_seen"] === "Y"'>

                      </button>
                      <button mat-button class="unread" *ngIf='element["has_been_seen"] !== "Y"'
                        (click)='$event.stopPropagation();singleRead(element ,"read")'>

                      </button>
                      <button mat-button class="unflaged" *ngIf='element["is_flagged"] === "N"'
                        (click)='$event.stopPropagation();changeFlagstats("Y" , element)'>

                      </button>
                      <button mat-button class="flagged" *ngIf='element["is_flagged"] === "Y"'
                        (click)='$event.stopPropagation();changeFlagstats("N" , element)'>

                      </button>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="notifColoumns;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: notifColoumns;"
                  [ngClass]='{"unread" : row["has_been_seen"] === "N"}'></tr>
              </table>
            </div>
            <div class="col-12" *ngIf="unReadnotifs.length > 0">
              <mat-paginator [pageSizeOptions]="unread.pageSizeOptions" [length]="unread.limit"
                [pageSize]="unread.pageSize" (page)="PageChange($event,'unread')" [pageIndex]="unread.index"
                showFirstLastButtons></mat-paginator>
            </div>
            <div class="col-12 text-center p-2" *ngIf="unReadnotifs.length == 0">
              No Notifications Found
            </div>
          </div>
        </mat-card>
      </div>
    </mat-tab>
    <mat-tab label="Flagged Notifications">
      <div class="col-12 ">
        <div class="gridCtrls">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="my-1  mr-1">

            </div>

          </div>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="my-1  mr-1">
              <span (click)="deleteNotif('flaggedNotifs' , 'Flaggedselection')"><img
                  src="assets/images/delete.svg"></span>
            </div>
            <div class="my-1  mr-1">
              <button mat-stroked-button (click)='updateReadStats("read" , "flaggedNotifs")'
                [disabled]="Flaggedselection.selected.length == 0">Mark as read</button>
            </div>
            <div class="my-1  mr-1">
              <button mat-stroked-button (click)='updateReadStats("unread" , "flaggedNotifs")'
                [disabled]="Flaggedselection.selected.length == 0">Mark as unread</button>
            </div>
            <!-- <div class="my-1  mr-1">
            <span (click)=initNOtif()><img src="assets/images/reset.svg"></span>
          </div> -->


          </div>
        </div>
        <mat-card class="p-0 overflow-hidden iop">
          <div class="mat-elevation-z8 checkBoxlign">
            <div class="table-responsive striped users_mod">
              <table class="col-12" mat-table matSort [dataSource]="flaggedNotifs">
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="checkbox_width text-center">
                    <mat-checkbox (change)="$event ? masterFlaggedToggle() : null"
                      [checked]="Flaggedselection.hasValue() && isAllFlaggedlSelected()"
                      [indeterminate]="Flaggedselection.hasValue() && !isAllFlaggedlSelected()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row" class="checkbox_width text-center">
                    <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="row.checkbox = $event.checked;$event ? Flaggedselection.toggle(row) : null"
                      [checked]="Flaggedselection.isSelected(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Date">
                  <th mat-header-cell *matHeaderCellDef> Date </th>
                  <td mat-cell *matCellDef="let element"> {{element.created |  date : 'MMM dd, yyyy, hh:mm a'}} </td>
                </ng-container>
                <ng-container matColumnDef="Subject">
                  <th class="date_width" mat-header-cell *matHeaderCellDef>Subject</th>
                  <td mat-cell *matCellDef="let element ;let i = index" (click)='getNotifDetails(element,i,"flagged")'>
                    {{element.subject}} </td>
                </ng-container>
                <ng-container matColumnDef="Actions">
                  <th class="date_width" mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <div class="action_array">
                      <button mat-button class="read" (click)='$event.stopPropagation();singleRead(element ,"unread")'
                        *ngIf='element["has_been_seen"] === "Y"'>

                      </button>
                      <button mat-button class="unread" *ngIf='element["has_been_seen"] !== "Y"'
                        (click)='$event.stopPropagation();singleRead(element ,"read")'>

                      </button>
                      <button mat-button class="unflaged" *ngIf='element["is_flagged"] === "N"'
                        (click)='$event.stopPropagation();changeFlagstats("Y" , element)'>

                      </button>
                      <button mat-button class="flagged" *ngIf='element["is_flagged"] === "Y"'
                        (click)='$event.stopPropagation();changeFlagstats("N" , element)'>

                      </button>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="notifColoumns;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: notifColoumns;"
                  [ngClass]='{"unread" : row["has_been_seen"] === "N"}'></tr>
              </table>
            </div>
            <div class="col-12" *ngIf="flaggedNotifs.length > 0">
              <mat-paginator [pageSizeOptions]="flagged.pageSizeOptions" [length]="flagged.limit"
                [pageSize]="flagged.pageSize" (page)="PageChange($event,'flagged')" [pageIndex]="flagged.index"
                showFirstLastButtons></mat-paginator>
            </div>
            <div class="col-12 text-center p-2" *ngIf="flaggedNotifs.length == 0">
              No Notifications Found
            </div>
          </div>
        </mat-card>
      </div>
    </mat-tab>
    <mat-tab label="Deleted Notifications">
      <div class="col-12 ">
        <div class="gridCtrls">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="my-1  mr-1">
            </div>
          </div>
          <div class="d-flex justify-content-between flex-wrap">

            <div class="my-1  mr-1">
              <button mat-stroked-button (click)="restoreNotif()"
                [disabled]="Delselection.selected.length == 0">Restore</button>
            </div>
            <!-- <div class="my-1  mr-1">
                <button mat-stroked-button (click)='updateReadStats("read")'  [disabled]="selection.selected.length == 0">Mark as read</button>
            </div>
            <div class="my-1  mr-1">
                <button mat-stroked-button  (click)='updateReadStats("unread")'[disabled]="selection.selected.length == 0">Mark as unread</button>
            </div> -->
            <!-- <div class="my-1  mr-1">
                <span (click)="getNotification('daleted')"><img src="assets/images/reset.svg"></span>
              </div> -->
          </div>
        </div>
        <mat-card class="p-0 overflow-hidden iop">
          <div class="mat-elevation-z8 checkBoxlign">
            <div class="table-responsive striped users_mod">
              <table class="col-12" mat-table matSort [dataSource]="Deletednotifications">
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="checkbox_width text-center">
                    <mat-checkbox (change)="$event ? masterDelToggle() : null"
                      [checked]="Delselection.hasValue() && isAllDelSelected()"
                      [indeterminate]="Delselection.hasValue() && !isAllDelSelected()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row" class="checkbox_width text-center">
                    <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="row.checkbox = $event.checked;$event ? Delselection.toggle(row) : null"
                      [checked]="Delselection.isSelected(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Date">
                  <th mat-header-cell *matHeaderCellDef> Date </th>
                  <td mat-cell *matCellDef="let element"> {{element.created |  date : 'MMM dd, yyyy, hh:mm a'}} </td>
                </ng-container>
                <ng-container matColumnDef="Subject">
                  <th class="date_width" mat-header-cell *matHeaderCellDef>Subject</th>
                  <td mat-cell *matCellDef="let element ;let i = index" (click)='getNotifDetails(element,i,"Delpage")'>
                    {{element.subject}} </td>
                </ng-container>
                <ng-container matColumnDef="Actions">
                  <th class="date_width" mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <div class="action_array">
                      <button mat-button class="read" (click)='$event.stopPropagation();singleRead(element ,"unread")'
                        *ngIf='element["has_been_seen"] === "Y"'>

                      </button>
                      <button mat-button class="unread" *ngIf='element["has_been_seen"] !== "Y"'
                        (click)='$event.stopPropagation();singleRead(element ,"read")'>

                      </button>
                      <button mat-button class="unflaged" *ngIf='element["is_flagged"] === "N"'
                        (click)='$event.stopPropagation();changeFlagstats("Y" , element)'>

                      </button>
                      <button mat-button class="flagged" *ngIf='element["is_flagged"] === "Y"'
                        (click)='$event.stopPropagation();changeFlagstats("N" , element)'>

                      </button>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="notifColoumns;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: notifColoumns;"
                  [ngClass]='{"unread" : row["has_been_seen"] === "N"}'></tr>
              </table>
            </div>
            <div class="col-12 text-center p-2" *ngIf="Deletednotifications.length == 0">
              No Notifications Found
            </div>
            <div class="col-12" *ngIf="Deletednotifications.length > 0">
              <mat-paginator [pageSizeOptions]="Delpage.pageSizeOptions" [length]="Delpage.limit"
                [pageSize]="Delpage.pageSize" (page)="PageChange($event,'Delpage')" [pageIndex]="Delpage.index"
                showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>